//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
	  name: 'Xinput',
	  props: ['xName','xClass','xMsg','xPlaceholder','xType','xMaxlength','xVal','xCola','xColb','xColc'],
   
	  data(){
	    return{
	    	val:this.xVal,
	     	icon_remove:false,
	    }
	  },
	  created: function(){
	
	  },
		methods: {
		 //处理手机号表单状态
			blur: function(){

			var me =this;
		    setTimeout(function(){
		        me.icon_remove = false;
		        me.$emit('blur',me.val.trim());
		    },1)

			
		  	},
		  	keyup:function () {
			  	if(!this.val){
			  		this.icon_remove = false;
			  	}
			  	else{
			  		this.icon_remove = true;
			  	}
		  	},
			focus:function(){
			    if(this.val){
			    	this.icon_remove = true;
			    }
			},
		  	onchange:function (){
		  		this.$emit('input',this.val.trim());
		  	},
		  	clear:function (){
		  		this.val="";
		  		this.$emit('input',this.val.trim());
		  		this.$refs.child.focus();
		  	},

		},
}



// WEBPACK FOOTER //
// ./src/components/Xinput.vue